import { ROUTES } from '@/routes/routeConfig'
import { useLocation, useNavigate } from 'react-router'
import { useSelector } from 'react-redux'
import { MTDuplicationRuleForm } from './MTDuplicationRuleForm'
import type { DuplicationRuleRow } from '@/multi-territory/mt-services/mt-duplication-rule-api'

/**
 * MTDuplicationRuleFormPage - Full-page wrapper for the Duplication Rule Add/Edit form.
 *
 * Opens as a routed page (like rule_setting/add-rule).
 * On cancel or success, navigates back to DUPLICATION_RULE.
 *
 * Location state:
 * - editingRule: DuplicationRuleRow | null (for edit mode)
 */
export function MTDuplicationRuleFormPage() {
  const navigate = useNavigate()
  const location = useLocation()

  const editingRule: DuplicationRuleRow | null = (location.state as any)?.editingRule ?? null

  const countryCode = useSelector(
    (state: { country: { countryCode: string } }) => state.country.countryCode
  )
  const selectedEntityUuid = useSelector(
    (state: any) => state.mtEntityTan?.selectedEntityUuid ?? ''
  )
  const selectedTanUuid = useSelector(
    (state: any) => state.mtEntityTan?.selectedTanUuid ?? ''
  )
  const entityMetaByUuid = useSelector(
    (state: any) => state.mtEntityTan?.entityMetaByUuid ?? {}
  )

  const selectedEntityMeta = entityMetaByUuid[selectedEntityUuid] || null
  const tanApplicable = selectedEntityMeta?.tanApplicable ?? true
  const tanMasterUuid = tanApplicable ? selectedTanUuid : selectedEntityUuid

  const handleClose = () => {
    navigate(-1)
  }

  const handleSuccess = () => {
    navigate(ROUTES.MT_RETURNS_DEFINE + '/DUPLICATION_RULE', {
      state: { refreshDuplicationRules: true },
    })
  }

  return (
    <MTDuplicationRuleForm
      open={true}
      onClose={handleClose}
      onSuccess={handleSuccess}
      editingRule={editingRule}
      countryCode={countryCode}
      tanMasterUuid={tanMasterUuid}
      tanApplicable={tanApplicable}
    />
  )
}